import { type EnumLike, type ZodTypeAny, z } from 'zod';

/**
 * A zod helper to create a nativeEnum with a default value which is optional.
 * That means:
 *  - the field is *not* required in the input schema, but has a default value when parsed.
 *  - while instantiating an instance of the _inferred_ interface, this field is optional
 *
 * Ultimately any instance of the inferred interface at runtime reflects the optional nature of the field but parses inputs with a prescribed default
 */
export function optionalEnum<T extends EnumLike>(
  nativeEnum: T,
  defaultValue: T[keyof T]
): z.ZodEffects<
  z.ZodDefault<z.ZodOptional<z.ZodNativeEnum<T>>>,
  T[keyof T] | undefined,
  T[keyof T] | undefined
> {
  return z
    .nativeEnum(nativeEnum)
    .optional()
    .default(defaultValue)
    .transform((arg) => arg ?? defaultValue);
}

export function oneOrMany<T extends ZodTypeAny>(schema: T) {
  return z.union([schema, z.array(schema)]);
}
